// Importing necessary libraries, action types, and helper functions
import CryptoJS from "crypto-js"; // Library for encryption
import * as types from "./ActionTypes"; // Importing action type constants
import { get, postLogin, getFrontagg } from "../Helper/index"; // Helper functions for API calls
import * as urls from "../../Uintls/Urls"; // Importing API endpoint URLs
import { clearAuthStorage, setFronteggAccessToken } from "../../authSession";

// Action to handle login requests
export const loginRequest = data => dispatch => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT; // Environment variable for encryption
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY; // Secret key for encryption
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data), // Encrypt the payload
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload }; // Encrypted payload
  dispatch({ type: types.LOGIN_API }); // Dispatch login API action
  get({
    url: `${urls.LOGIN_URL}`, // API endpoint for login
    success: types.SET_LOGIN, // Action type for successful login
    failure: types.SET_ERROR, // Action type for failed login
    dispatch, // Dispatch function
    body: encryptionKey === "NO" ? data : payload, // Use encrypted payload if encryption is enabled
  });
};

// Action to handle login requests via Frontegg
export const loginRequestFrontegg = userTokenData => dispatch => {
  dispatch({ type: types.LOGIN_API }); // Dispatch login API action
  return getFrontagg({
    url: `${urls.FRONTEGG_URL}`, // API endpoint for Frontegg login
    success: types.SET_LOGIN, // Action type for successful login
    failure: types.SET_ERROR, // Action type for failed login
    dispatch, // Dispatch function
    userTokenData, // User token data for authentication
  });
};

// Action to handle Viking login requests
export const loginRequestViking = data => dispatch => {
  dispatch({ type: types.VIKING_LOGIN_CALL }); // Dispatch Viking login call action
  postLogin({
    url: `${urls.VIKING_LOGIN_URL}`, // API endpoint for Viking login
    success: types.VIKING_LOGIN_SUCCESS, // Action type for successful login
    failure: types.VIKING_LOGIN_ERROR, // Action type for failed login
    dispatch, // Dispatch function
    body: data, // Login data
  });
};

// Action to fetch the user list
export const getUserList = () => dispatch => {
  dispatch({ type: types.USER_LIST_CALL }); // Dispatch user list call action
  get({
    url: urls.USER_LIST_URL, // API endpoint for fetching user list
    success: types.USER_LIST_SUCCESS, // Action type for successful response
    failure: types.USER_LIST_ERROR, // Action type for failed response
    dispatch, // Dispatch function
  });
};

// Action to handle OTP requests
export const getOtpCall = data => dispatch => {
  dispatch({ type: types.GET_OTP_CALL }); // Dispatch OTP call action
  get({
    url: `${urls.LOGIN_OTP_URL}`, // API endpoint for OTP
    success: types.GET_OTP_SUCCESS, // Action type for successful OTP response
    failure: types.GET_OTP_ERROR, // Action type for failed OTP response
    dispatch, // Dispatch function
    body: data, // OTP request data
  });
};

// Action to fetch the client theme configuration
export const clientThemeCall = () => dispatch => {
  dispatch({ type: types.CLIENT_THEME_CALL }); // Dispatch client theme call action
  get({
    url: `${urls.PROVIDERS_PORTAL_THEME_URL}`, // API endpoint for client theme
    success: types.SET_CLIENT_THEME, // Action type for successful response
    failure: types.CLIENT_THEME_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: false, // No request body
  });
};

// Action to set the user role in the Redux store
export const setUserRole = data => ({
  type: types.SET_USER_ROLE, // Action type for setting user role
  data, // User role data
});

// Action to handle user logout
export const logout = () => ({
  type: types.SET_LOUGOUT, // Action type for logout
});

// ===== CUSTOM AUTH ORCHESTRATION (Option B) =====

// Centralized logout action for custom auth
export const authLogout = () => dispatch => {
  clearAuthStorage();
  setFronteggAccessToken(null);
  dispatch({
    type: types.AUTH_LOGOUT,
  });
};

// Set auth error
export const authSetError = (error) => ({
  type: types.AUTH_SET_ERROR,
  payload: error,
});

// Clear auth error
export const authClearError = () => ({
  type: types.AUTH_CLEAR_ERROR,
});

// Action to set the app bar name
export const setAppBarName = data => ({
  type: types.SET_NAME_APPBAR, // Action type for setting app bar name
  data, // App bar name data
});

// Action to set the layout name
export const setLayoutName = data => ({
  type: types.SET_LAYOUT_IN_APP, // Action type for setting layout name
  data, // Layout name data
});

// Action to fetch client portal configuration
export const clientPortalConfig = () => dispatch => {
  dispatch({ type: types.CLIENT_PORTAL_CONFIG_CALL }); // Dispatch client portal config call action
  get({
    url: `${urls.PROVIDER_PANEL_DATA_URL}`, // API endpoint for client portal configuration
    success: types.CLIENT_PORTAL_CONFIG_SUCCESS, // Action type for successful response
    failure: types.CLIENT_PORTAL_CONFIG_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: false, // No request body
  });
};

// Action to fetch the user left menu configuration
export const getUserLeftMenuCall = () => dispatch => {
  dispatch({ type: types.USER_LEFT_MENU_CALL }); // Dispatch user left menu call action
  get({
    url: `${urls.USER_LEFT_MENU_URL}`, // API endpoint for user left menu
    success: types.USER_LEFT_MENU_SUCCESS, // Action type for successful response
    failure: types.USER_LEFT_MENU_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: false, // No request body
  });
};
